export const SUBSCRIPTIONS_PAGINATION = {
  PAGES_LIMIT: 30,
};
